<template>
  <div class="container">
    <div class="row" style="margin-top: 115px">
      <div class="col-md-3">
        <sidebar />
      </div>
      <div class="col-md-9">
        <center>
          <pulse-loader style="margin: 15px" :loading="$store.getters.getLoaData.isLoading" color="#696969" size="10px"></pulse-loader>
        </center>
        <div v-show="!$store.getters.getLoaData.isLoaRequested || $store.getters.getLoaData.status_loa === '3'" class="alert alert-warning fade in nomargin">
          <h4>Letter of Acceptance</h4>
          <p>Anda dapat mengajukan surat ini setelah mendapat pengumuman bahwa Anda diterima sebagai mahasiswa UIN Sunan Kalijaga Yogyakarta.</p>
          <p>
            <button @click="reqLoa" class="btn btn-warning mt-xs mb-xs" type="button">Ajukan LoA</button>
          </p>
        </div>
        <hr class="tall">
        <h4 v-show="$store.getters.getLoaData.isLoaRequested">Status Pengajuan LoA</h4>
        <div v-show="$store.getters.getLoaData.isLoaRequested && $store.getters.getLoaData.status_loa === '1'" class="progress">
          <div class="progress-bar progress-bar-primary progress-bar-striped active" role="progressbar" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style="width: 50%">Sedang direview
            <span class="sr-only">Sedang direview</span>
          </div>
        </div>
        <div v-show="$store.getters.getLoaData.isLoaRequested && $store.getters.getLoaData.status_loa === '2'">
          <section class="call-to-action mb-xl">
            <div class="call-to-action-content">
              <p>Pengajuan LoA Anda telah disetujui.</p>
            </div>
            <center>
              <pulse-loader style="margin: 15px" :loading="loaLoading" color="#696969" size="10px"></pulse-loader>
            </center>
            <div class="call-to-action-btn">
              <a v-show="loaExist" :href="link" target="_blank" class="btn btn-lg btn-primary">Download</a>
            </div>
          </section>
        </div>
        <div v-if="$store.getters.getLoaData.status_loa === '3'">
          <section class="call-to-action mb-xl">
            <div class="call-to-action-content">
              <p>Maaf, pengajuan LoA Anda telah ditolak. Alasan penolakan: </p>
              <p>{{ $store.getters.getLoaData.loa_data.keterangan }}</p>
            </div>
          </section>
        </div>
      </div>
      <div class="visible-xs">
        <div class="col-md-12">
          <h4 class="heading-primary"><i class="fa fa-bullhorn"></i> Pengumuman</h4>
          <ul class="nav nav-list mb-xlg sort-source">
            <li
              v-for="item in $store.state.pengumuman.randomThree.filter(el => el)"
              :key="item.id"
            >
              <a
                @click="() => goToDetailPengumuman(item.id_pengumuman)"
                style="cursor: pointer"
                >{{ item.judul }}</a
              >
            </li>
          </ul>
          <h4 class="heading-primary"><i class="fa fa-newspaper-o"></i> Artikel</h4>
          <ul class="nav nav-list mb-xlg sort-source">
            <li
              v-for="item in $store.state.artikel.randomThree.filter(el => el)"
              :key="item.id"
            >
              <a
                @click="() => goToDetailArtikel(item.id_berita)"
                style="cursor: pointer"
              >
                {{ item.judul }}</a
              >
            </li>
            <li>
              <a @click="() => goToCardArtikel()" style="cursor: pointer">
                <h6 class="heading-primary">
                  Selengkapnya...
                </h6>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { base } from '@/api/data'

export default {
  name: 'RLoA',
  data () {
    return {
      loaLoading: false,
      loaExist: false,
      link: '',
      statusLoa: null,
      isRequested: false
    }
  },
  beforeCreate () {
    let isLogin = this.$store.getters.getAuthData.isLogin
    // eslint-disable-next-line
    !isLogin ? this.$router.push({name: 'Login'}) : false
  },
  mounted () {
    this.checkLoaStatus()
    this.checkLoa()
  },
  computed: {
    breadcrumbList () {
      let list = this.$route.path.split('/')
      list.shift()
      for (let i = 0; i < list.length; i++) {
        list[i] = list[i].charAt(0).toUpperCase() + list[i].slice(1)
      }
      return list
    }
  },
  methods: {
    checkLoaStatus () {
      this.loaLoading = this.$store.getters.getLoaData.isLoading
      // this.isRequested = this.$store.getters.getLoaData.isLoaConditionalRequested
      this.statusLoa = this.$store.dispatch('getStatusLoa', {nomor_peserta: 'peserta'})
    },
    reqLoa () {
      this.loaLoading = true
      return new Promise((resolve, reject) => {
        this.$store.dispatch('requestLoa', {
          nomor_pendaftar: this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar,
          // nomor_peserta: 'peserta',
          nomor_peserta: this.$store.getters.getAuthData.data.no_peserta,
          jenis_loa: '2',
          tahun: this.$store.getters.getAuthData.dataYudisium.tahun,
          kode_prodi: this.$store.getters.getAuthData.dataYudisium.kode_prodi,
          kode_jalur: this.$store.getters.getAuthData.dataYudisium.kode_jalur,
          // tahun: '2019',
          // kode_prodi: 1,
          // kode_jalur: 8522019,
          status_loa: '1'
        })
          .then(response => {
            // this.$store.dispatch('getStatusLoa', {nomor_peserta: this.$store.getters.getAuthData.data.no_peserta})
            this.$store.dispatch('getStatusLoa', {nomor_peserta: 'peserta'})
            this.loaLoading = false
            resolve(true)
          })
          .catch(e => {
            e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    checkLoa () {
      this.loaLoading = true
      api.get('/v2/loa/cek/2/' + this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.loaLoading = false
            this.loaExist = true
            this.link = base + 'storage/download/loa/loa_2_' + this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar + '.pdf'
          }
        })
        .catch(e => {
          if (e.response.status === 429) {
            this.flash('Mohon maaf server tidak dapat merespon dengan baik', 'error', {timeout: 3000})
          }
          // FIXME: Tell our user when we got some errors
          console.log(e)
          this.loaLoading = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/RLoA.vue